var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.68868C15.405 1.97506 14.771 2.16489 14.11 2.25706C14.79 1.81157 15.309 1.11152 15.553 0.267731C14.919 0.682494 14.219 0.975461 13.473 1.13895C12.871 0.435611 12.013 0 11.077 0C9.261 0 7.799 1.61736 7.799 3.6001C7.799 3.88539 7.821 4.1597 7.875 4.42085C5.148 4.27491 2.735 2.8408 1.114 0.65616C0.831 1.19491 0.665 1.81157 0.665 2.47541C0.665 3.7219 1.25 4.82683 2.122 5.46653C1.595 5.45556 1.078 5.28768 0.64 5.02324C0.64 5.03421 0.64 5.04848 0.64 5.06274C0.64 6.81177 1.777 8.26454 3.268 8.5992C3.001 8.6793 2.71 8.71771 2.408 8.71771C2.198 8.71771 1.986 8.70454 1.787 8.65626C2.212 10.0816 3.418 11.1295 4.852 11.1635C3.736 12.1214 2.319 12.6986 0.785 12.6986C0.516 12.6986 0.258 12.6854 0 12.6492C1.453 13.6773 3.175 14.2643 5.032 14.2643C11.068 14.2643 14.368 8.77806 14.368 4.02254C14.368 3.86344 14.363 3.70983 14.356 3.55731C15.007 3.05037 15.554 2.41726 16 1.68868Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.507ceade7009bead7f1441abbeb2575c.svg";
export { ForwardRef as ReactComponent };